import { glowStyle, logoStyle, mobileLogoStyle } from "./logo.css"

function Logo({
  width = "80px",
  isMob,
  glow,
}: {
  width?: string
  isMob?: boolean
  glow?: boolean
}) {
  return (
    <img
      src="/logo.webp"
      alt="Rescape AI"
      className={`${logoStyle} ${isMob ? mobileLogoStyle : ""} ${glow ? glowStyle : ""}`}
      width={width}
      height={`calc(1.35 * ${width})`}
    />
  )
}

export default Logo
